import { useOktaAuth } from '@okta/okta-react'
import { useRouter } from 'next/router'
import { useCallback } from 'react'

import { LocalStorageKey, useLocalStorage } from '~/components/hooks/useLocalStorage'
import { SSOLoginPage } from '~/components/SSOLoginPage'
import { SsoIdentityProvider } from '~/graphql/generated/query.types'

const SSOPage = () => {
  const router = useRouter()
  const [_expectedEmail, setExpectedEmail] = useLocalStorage(LocalStorageKey.OKTA_EXPECTED_EMAIL)
  const oktaAuth = useOktaAuth()

  const ssoIdentityProvider = router.query.ssoIdentityProvider as SsoIdentityProvider
  const email = router.query.email as string

  const handleSSOLogin = useCallback(async () => {
    setExpectedEmail(email)
    await oktaAuth.oktaAuth.signInWithRedirect()
  }, [email, oktaAuth.oktaAuth, setExpectedEmail])

  return (
    <SSOLoginPage
      email={email}
      ssoIdentityProvider={ssoIdentityProvider}
      onLogin={handleSSOLogin}
    />
  )
}

export default SSOPage
